import Vue from 'vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export function notify(title, variant = 'danger', icon = 'AlertCircleIcon') {
  if (!title || !Vue.prototype.$toast) return
  Vue.prototype.$toast({
    component: ToastificationContent,
    props: {
      title,
      variant,
      icon,
    },
  })
}

export const notifySuccess = title => notify(title, 'success', 'CheckIcon')
